import forEach from "lodash/forEach";
import get from "lodash/get";
import has from "lodash/has";
import set from "lodash/set";
import unset from "lodash/unset";

const STORAGE_KEY = "Directly_RTM";
const { localStorage } = window;

let instance;

export class ChatStorage {
    constructor() {
        if (!instance) {
            instance = this;
        }

        this.chatConfigId = undefined;
        this.storageEngine = localStorage;
        this.state = {};

        return instance;
    }

    init({ chatConfigId }) {
        this.chatConfigId = chatConfigId;

        if (this.mainStorageKeyWasInitialized()) {
            const stateFromStorageEngine = this.storageEngine.getItem(STORAGE_KEY);

            this.state = JSON.parse(stateFromStorageEngine);
        } else {
            this.initializeMainStorageKey();
        }
        this.cleanUpLegacy();
    }

    setItem(key, value) {
        if (!this.chatConfigId) return;

        set(this.state, `${this.chatConfigId}.${key}`, value);
        this.flush();
    }

    removeKey(key) {
        if (!this.chatConfigId) return;
        if (!has(this.state, `${this.chatConfigId}.${key}`)) return;

        unset(this.state, `${this.chatConfigId}.${key}`);
        this.flush();
    }

    getItem(key) {
        const stateFromStorageEngine = JSON.parse(this.storageEngine.getItem(STORAGE_KEY));

        return get(stateFromStorageEngine, `${this.chatConfigId}.${key}`, undefined);
    }

    mainStorageKeyWasInitialized() {
        return Boolean(this.storageEngine.getItem(STORAGE_KEY));
    }

    initializeMainStorageKey() {
        this.flush();
    }

    flush() {
        const serializedState = JSON.stringify(this.state);

        this.storageEngine.setItem(STORAGE_KEY, serializedState);
    }

    cleanUpLegacy() {
        const legacyKeys = ["directly_rtm_location", "directly_chat"];

        forEach(legacyKeys, key => {
            const keyExists = Boolean(this.storageEngine.getItem(key));

            if (keyExists) {
                this.storageEngine.removeItem(key);
            }
        });
        this.removeKey("sessionId");
        this.removeKey("sessionToken");
    }
}

instance = new ChatStorage();

export default instance;
